import { useRef } from "react";
import HeroBanner from "../../base/HeroBanner/HeroBanner";
import SinglePage from "../SinglePage/SinglePage";
import { Container } from "./styles";
import { smoothScrollTo } from "../../functionallity/smoothScrollTo";
import TopicIntro from "../../base/Topic/TopicIntro";
import AboutAccordion from "./AboutAccordion/AboutAccordion";

const AboutAccordionProps = [
    {
        timePeriod: "2009-2011",
        summaryText: "Die Gründung: Von den ersten Ideen bis zum ersten Umzug",
        detailsText: "Yvonne Schumann und Dominik Fix entwickelten unabhängig voneinander die Idee, eine eigene Hexenzunft zu gründen. Yvonne, inspiriert von Sulgens Vergangenheit und dem Bild von „sulenden Schweinen“, schlug den Namen Moorhexen vor. Dominik wollte mit den Eckenwaldhexen seiner Heimat, dem Eckenhof, Tribut zollen. Durch einen Hinweis von Eva kamen beide zusammen und entschieden sich für den gemeinsamen Namen „Eckenmoorhexen“, der beide Konzepte vereint.Am Fasnetsdienstag 2010 formierten sich die sieben Gründungsmitglieder: Yvonne Schumann, Dominik Fix, Felix Ehret, Michael Baumgartner, Carina Storz, Lukas Schifer und Eva Nöhre. Mit Unterstützung eines Maskenschnitzers und der Firma Fischer wurden Masken und Gewänder im Stil von „Moor“ und „Wald“ gestaltet. So entstand die Eckenmoorhexen-Zunft, die ihre Wurzeln in Tradition und regionaler Verbundenheit hat.",
        imagePath: require('../../../assets/images/About/AboutAccordion/PW20230219_15-10-38DSC07630.png')
    },
    {
        timePeriod: "2012-2018",
        summaryText: "Der Wachstum bis zum Knacken der 50-Mitgliedermarke",
        detailsText: "Nach der Gründung 2010 wuchsen die Eckenmoorhexen stetig. Mit ihren eindrucksvollen Masken und Gewändern zogen sie bei Umzügen und Veranstaltungen immer mehr Aufmerksamkeit auf sich. Neue Mitglieder fühlten sich durch die offene und herzliche Atmosphäre schnell willkommen.Der Zusammenhalt in der Gruppe und die Begeisterung für die Fasnet trugen dazu bei, dass die Zunft bald die Marke von 50 Mitgliedern knackte. Dieser Meilenstein zeigt, wie aus einer kleinen Idee eine lebendige Gemeinschaft entstehen kann.",
        imagePath: require('../../../assets/images/About/AboutAccordion/groupPic.png')
    },
    {
        timePeriod: "2019-2022",
        summaryText: "Vom Beginn des Baus des Wagens bis zu seiner Fertigstellung",
        detailsText: "Der Bau des ersten Fasnetswagens war für die Eckenmoorhexen ein großes Projekt, das mit viel Einsatz und Kreativität umgesetzt wurde. Von der ersten Idee bis zur Fertigstellung dauerte es mehrere Monate, in denen die Mitglieder ihre Abende und Wochenenden mit Planen, Schrauben und Malen verbrachten. Ziel war es, einen Wagen zu schaffen, der die Themen „Moor“ und „Wald“ perfekt widerspiegelt und die Zunft bei Umzügen repräsentiert. Möglich wurde dieses Vorhaben durch die großzügige Unterstützung zahlreicher Spender und helfender Hände. Ein herzlicher Dank geht an alle, die Material, Zeit oder finanzielle Mittel beigesteuert haben. Ohne diesen Zusammenhalt wäre der Bau des Wagens nicht möglich gewesen. Am Ende stand ein Wagen, der sowohl die Mitglieder als auch die Zuschauer begeisterte und ein echtes Highlight für die Eckenmoorhexen wurde.",
        imagePath: require('../../../assets/images/About/AboutAccordion/car.jpg')
    },
    {
        timePeriod: "2023-heute",
        summaryText: "Après-Summer-Party, Mallorca-Ausfahrt und vieles mehr",
        detailsText: "Die Eckenmoorhexen sind nicht nur während der Fasnet aktiv, sondern auch das ganze Jahr über. Ein besonderes Highlight ist die jährliche Mallorca-Ausfahrt, bei der die Mitglieder den Ballermann unsicher machen – diesmal ohne Hexenkostüme, aber mit umso mehr guter Laune. Diese Tradition hat sich fest etabliert und sorgt immer wieder für unvergessliche Momente abseits des närrischen Trubels. Die Après-Summer-Party feierte im Jahr 2024 ein erfolgreiches Comeback. Nach längerer Pause wurde die Veranstaltung in Seedorf wiederbelebt und entwickelte sich direkt zu einem vollen Erfolg. Mit cooler Musik, super Stimmung und vielen Gästen wurde bis spät in die Nacht gefeiert.",
        imagePath: require('../../../assets/images/About/AboutAccordion/PW20230219_15-20-12DSC07747.png')
    },
];

const About = () => {
    const topicIntroRef = useRef<HTMLDivElement>(null);

    const scrollToTopicIntro = () => {
        if (topicIntroRef.current) {
            smoothScrollTo(topicIntroRef.current, 2000);
        }
    };
    return (<SinglePage
        title='Über Uns'
        heroBanner={
            <HeroBanner 
            imageSource = {require('../../../assets/images/About/smokingWitch.png')}
            headline="ÜBER UNS."
            text="Erfahre mehr über die berüchtigen Eckenmoorhexen vom Sulgen." 
            onNextSection={scrollToTopicIntro}
            />
        }
        topic={
            <div ref={topicIntroRef}>
                <TopicIntro
                headline="ÜBER UNS."
                introductionText="Seit unserer Gründung im Jahr 2011 ist bei den Eckenmoorhexen viel passiert. 
                In kleinen Etappen blicken wir hier auf die besonderen Momente, Erfolge und Ereignisse zurück, 
                die unseren Verein geprägt haben. Von unseren ersten Auftritten über Meilensteine in der Vereinsgeschichte 
                bis hin zu unvergesslichen Fasnetserlebnissen – jede Station erzählt ein Stück unserer gemeinsamen Geschichte."
                />
            </div>
        }
        content={
            <>
                <Container>
                    {AboutAccordionProps.map((member, index) => (
                        <AboutAccordion key={index} timePeriod={member.timePeriod} summaryText={member.summaryText} detailsText={member.detailsText} imagePath={member.imagePath}/>
                    ))}
                </Container>
            </>
        }
        >
    </SinglePage>
    );
}
 
export default About;